import {
    Box,
    Paper, Typography, useTheme,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
import React, { useEffect, useMemo, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { ILstDrop, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import { EstatisticasService, IDadosJogadoresLideres, IDetalheJogadorLider } from "../../shered/services/api/estatisticas/EstatisticasService";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Loading } from "../../shered/components/loading/Loading";


export const ListagemDeJogadoresLideres: React.FC = () => {
    const theme = useTheme();
    const { themeName } = useAppThemeContext();
    const { debounce } = useDebounce();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    //const user = CookieService.get("access_user");
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [semImagemFranquia, setSemImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [searchParams, SetSearchParams] = useSearchParams();
    const [estatisticasDados, setEstatisticasDados] = useState<IDadosJogadoresLideres>();
    const [estatisticasTotalRows, setEstatisticasTotalRows] = useState<IDetalheJogadorLider[]>([]);
    const [estatisticasStatsRows, setEstatisticasStatsRows] = useState<IDetalheJogadorLider[]>([]);
    const [codigoStatsFiltro, setCodigoStatsFiltro] = useState(7);
    const [temporadaFiltro, setTemporadaFiltro] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [listaStats, setListaStats] = useState<ILstDrop[]>([]);

    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const columnsTotalGeral: GridColDef[] = [
        {
            field: 'codigo_Jogador',
            headerName: '',
            flex: 1,
            minWidth: 58,
            maxWidth: 58,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'posicao',
            headerName: 'POS.',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 70,
            maxWidth: UtilidadeService.isMobile() ? 60 : 70,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'foto_Jogador',
            headerName: 'FOTO',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 70,
            maxWidth: UtilidadeService.isMobile() ? 60 : 70,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => params.value !== null ? <img src={params.value} width={45} height={50} /> : null,
        },
        {
            field: 'nome_Jogador',
            headerName: 'JOGADOR',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 100 : 130,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'logo_Franquia',
            headerName: 'LOGO',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 70,
            maxWidth: UtilidadeService.isMobile() ? 60 : 70,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => <img src={params.value === null ? semImagemFranquia : params.value} width={45} height={50} />,
        },
        {
            field: 'nome_Franquia',
            headerName: 'FRANQUIA',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 100 : 130,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'valor_Stats',
            headerName: 'TOTAL',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 70,
            maxWidth: UtilidadeService.isMobile() ? 60 : 70,
            sortable: UtilidadeService.isMobile() ? false : true,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        }
    ];

    const columnsStatsGeral: GridColDef[] = [
        {
            field: 'codigo_Jogador',
            headerName: '',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 70,
            maxWidth: UtilidadeService.isMobile() ? 60 : 70,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'posicao',
            headerName: 'POS.',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 70,
            maxWidth: UtilidadeService.isMobile() ? 60 : 70,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'foto_Jogador',
            headerName: 'FOTO',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 70,
            maxWidth: UtilidadeService.isMobile() ? 60 : 70,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => params.value !== null ? <img src={params.value} width={45} height={50} /> : null,
        },
        {
            field: 'nome_Jogador',
            headerName: 'JOGADOR',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 100 : 130,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'logo_Franquia',
            headerName: 'LOGO',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 70,
            maxWidth: UtilidadeService.isMobile() ? 60 : 70,
            sortable: UtilidadeService.isMobile() ? false : true,
            editable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => <img src={params.value === null ? semImagemFranquia : params.value} width={45} height={50} />,
        },
        {
            field: 'nome_Franquia',
            headerName: 'FRANQUIA',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 100 : 130,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'valor_Stats',
            headerName: 'TOTAL',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 70,
            maxWidth: UtilidadeService.isMobile() ? 60 : 70,
            sortable: UtilidadeService.isMobile() ? false : true,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        }
    ];

    useEffect(() => {
        setIsLoading(true);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar("/dashboard");
            return;
        } else {
            debounce(() => {
                UtilidadeService.getTemporadasLiga(Number(codigoLiga))
                    .then((result) => {
                        const tmps = result.data.dado;
                        let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                        setLstTemporadas(lstTemporadasAux);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;

                    });

                UtilidadeService.getStatsLigaPorCodigoLiga(Number(codigoLiga))
                    .then((result) => {
                        setIsLoading(false);
                        const lstStats = result.data.dado;
                        let lst = lstStats.map((m) => ({ codigo: m.codigo, label: m.nome }));
                        setListaStats(lst);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    });

                LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                    .then((result) => {
                        const liga = result.dado;
                        setDadosLiga(liga);
                        if (liga.caminho_Logo !== null) {
                            setSemImagemFranquia(liga.caminho_Logo);
                        }
                        setTemporadaFiltro(liga.codigo_Temporada);
                        carregarDados(liga.codigo_Temporada, codigoStatsFiltro);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }

                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            setRedirecionar(`/usuario/liga/${codLocal}`);
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    });
            })
        }
    }, []);

    const carregarDados = (codigoTemporada: number, codigoStats: number) => {
        setIsLoading(true);
        setRemoveLoading(false);

        EstatisticasService.getStatsJogadoresLideres(Number(codigoLiga), codigoTemporada, codigoStats)
            .then((result) => {
                const dados = result.dado;

                setEstatisticasDados(dados);
                setEstatisticasTotalRows(dados === null ? [] : dados.jogador_Stats_Total);
                setEstatisticasStatsRows(dados === null ? [] : dados.jogador_Stats_Jogo);
                setIsLoading(false);
                setRemoveLoading(true);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });

                setRedirecionar(`/usuario/liga/${codLocal}`);
                return;
            });
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    }

    const handleSelectedTemporada = async (e: { target: { name: string; value: any; }; }) => {
        setTemporadaFiltro(e.target.value);
        carregarDados(e.target.value, codigoStatsFiltro);

    }

    const handleCarregarDadosstats = async (e: { target: { name: string; value: any; }; }) => {
        setCodigoStatsFiltro(Number(e.target.value));
        carregarDados(temporadaFiltro, Number(e.target.value));

    }



    return (
        <LayoutBaseDePagina
            titulo={`Jogadores Lideres - ${dadosLiga?.nome}`}
            showLogoImg={semImagemFranquia}
            barraDeFerramentas={<FerramentasDaListagem
                textoBotaoNovo="Nova"
                mostrarBotaoNovo={false}
                mostrarInputBusca={false}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
            />}>

            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Box margin={1} display="flex" component={Paper} variant="outlined"  >
                <Grid container size={{ xs: 12, sm: 12 }} sx={{ width: "100%" }}>
                    <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={2} >
                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1}>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6"> Jogadores Lideres </Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial" spacing={2}>
                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={temporadaFiltro}
                                            label="Temporadas"
                                            onChange={(handleSelectedTemporada)}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }

                                        </Select>
                                    </FormControl >
                                </Grid>
                                <Grid size={{ xs: 12, sm: 3, md: 3 }} display="flex" justifyContent="center">
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Stats</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={codigoStatsFiltro}
                                            label="Stats"
                                            onChange={handleCarregarDadosstats}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                listaStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }
                                        </Select>
                                    </FormControl >
                                </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}>
                                {isLoading && !removeLoading && <Loading />}
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 12 }} spacing={1} style={{ paddingTop: "16px" }}>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    {estatisticasTotalRows.length > 0 ? (
                                        <>
                                            <Grid size={{ xs: 12, sm: 12 }}>
                                                <Typography variant="body1"> {`${estatisticasDados?.nome_Stats} Total`}</Typography>
                                                <hr />
                                            </Grid>
                                            <Box sx={{
                                                height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                '& .super-app-theme--header': {
                                                    backgroundColor: theme.palette.common.black,
                                                    color: theme.palette.common.white,
                                                },
                                                '& .super-app.negative': {
                                                    color: 'red',
                                                    fontWeight: 'bold'
                                                },
                                                '& .super-app.positive': {
                                                    color: "#00e676",
                                                    fontWeight: '600',
                                                },
                                                '& .super-app-theme--cell': {
                                                    color: '#00e676',
                                                    fontWeight: '600',
                                                },
                                            }}>
                                                <DataGrid
                                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                    getRowId={(r) => r.codigo_Jogador}
                                                    rows={estatisticasTotalRows}
                                                    columns={columnsTotalGeral}
                                                    initialState={{
                                                        pagination: {
                                                            paginationModel: {
                                                                pageSize: 10,
                                                            },
                                                        },
                                                    }}
                                                    columnVisibilityModel={{
                                                        codigo_Jogador: false,
                                                    }}
                                                    disableDensitySelector
                                                    disableVirtualization
                                                    pageSizeOptions={[10, 25, 50, 75, 100]}
                                                    disableRowSelectionOnClick
                                                    disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                    disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                    hideFooter
                                                    rowHeight={40}
                                                    columnHeaderHeight={32}
                                                    sx={{
                                                        fontSize: UtilidadeService.isMobile() ? 11 : 13,
                                                    }}
                                                />
                                            </Box>
                                        </>

                                    )
                                        :
                                        <Grid size={{ xs: 12, sm: 12 }} >
                                            <Typography variant="h6">Não possui dados para a temporada selecionada!</Typography>
                                        </Grid>
                                    }
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }}  >
                                    {estatisticasTotalRows.length > 0 && (
                                        <>
                                            <Grid size={{ xs: 12, sm: 12 }}>
                                                <Typography variant="body1">  {`${estatisticasDados?.nome_Stats} por jogo`}</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12 }}>
                                                <Box sx={{
                                                    height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                    '& .super-app-theme--header': {
                                                        backgroundColor: theme.palette.common.black,
                                                        color: theme.palette.common.white,
                                                    },
                                                    '& .super-app.negative': {
                                                        color: 'red',
                                                        fontWeight: 'bold'
                                                    },
                                                    '& .super-app.positive': {
                                                        color: "#00e676",
                                                        fontWeight: '600',
                                                    },
                                                    '& .super-app-theme--cell': {
                                                        color: '#00e676',
                                                        fontWeight: '600',
                                                    },
                                                }}>
                                                    <DataGrid
                                                        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                        getRowId={(r) => r.codigo_Jogador}
                                                        rows={estatisticasStatsRows}
                                                        columns={columnsStatsGeral}
                                                        initialState={{
                                                            pagination: {
                                                                paginationModel: {
                                                                    pageSize: 10,
                                                                },
                                                            },
                                                        }}
                                                        columnVisibilityModel={{
                                                            codigo_Jogador: false,
                                                        }}
                                                        disableDensitySelector
                                                        disableVirtualization
                                                        pageSizeOptions={[10, 25, 50, 75, 100]}
                                                        disableRowSelectionOnClick
                                                        disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                        disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                        hideFooter
                                                        rowHeight={40}
                                                        columnHeaderHeight={32}
                                                        sx={{
                                                            fontSize: UtilidadeService.isMobile() ? 11 : 13,
                                                        }}
                                                    />
                                                </Box>
                                            </Grid>
                                        </>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </LayoutBaseDePagina >
    )
}


